import { videosApi } from "@api/api/api";
import axios from "axios";

export const uploadVideo = async (file, setTotalBytesUploaded) => {
	const url = `${videosApi}upload`;
	return await axios.post(url, file, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
		onUploadProgress: (progressEvent) => setTotalBytesUploaded(progressEvent.loaded),
	});
};

export const convertVideo = async (body) => {
	return await axios
		.post(`${videosApi}convert_video`, {
			savepath:
				body.savepath
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "")
					.replace(/[()]/g, "") +
				"/" +
				body.uuid +
				"/",
			filename: body.filename,
		})
		.then((res) => {
			return res;
		})
		.catch((error) => {
			console.error(error);
		});
};

export const getStatus = async (savepath) => {
	return await axios
		.get(`${videosApi}video_status?savepath=${savepath}`)
		.then((res) => {
			return res;
		})
		.catch((error) => {
			console.error(error);
			return error;
		});
};

export const lastStep = async (savepath: string) => {
	return await axios
		.post(`${videosApi}video_format`, { savepath: savepath })
		.then((res) => {
			return res;
		})
		.catch((error) => {
			console.error(error);
			return error;
		});
};
